import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { configs } from '@constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';

const {
    endpoints,
    routes,
    states: {
        PENNSYLVANIA,
        NEVADA,
        NEW_JERSEY,
        NEW_MEXICO,
        CALIFORNIA,
        MINNESOTA,
        IDAHO,
        GEORGIA,
        VIRGINIA,
        ILLINOIS,
        GETINSURED,
    },
} = configs;

let url = window.location.href.split('/');
const encTicketId = url[url.length - 2];

export const ticketManagementNavLinkNames = {
    CREATE_TICKET: 'sidenav_ticketmgmt_create_ticket',
    MANAGE_TICKET: 'sidenav_ticketmgmt_manage_tickets',
    MANAGE_WORKGROUP: 'sidenav_ticketmgmt_manage_workgroup',
    MANAGE_WORKGROUP_ASSIGNEES: 'sidenav_ticketmgmt_manage_workgroup_assignees',
    MANAGE_TICKET_TYPES: 'sidenav_ticketmgmt_manage_ticket_types',
    MANAGE_EXCHANGE_ASSIGNEES: 'sidenav_ticketmgmt_manage_exchange_assignees',
    MANAGE_TAGS: 'sidenav_ticketmgmt_manage_tags',
    MANAGE_CUSTOM_FIELD: 'sidenav_ticketmgmt_manage_custom_fields',
    MANAGE_CANNED_RESPONSE: 'sidenav_ticketmgmt_manage_canned_response',
    TICKET_DETAIL: 'sidenav_ticketmgmt_ticket_detail',
    TICKET_HISTORY: 'sidenav_ticketmgmt_ticket_history',
    TICKET_COMMENTS: 'sidenav_ticketmgmt_ticket_comments',
    TICKET_DOCUMENTS: 'sidenav_ticketmgmt_ticket_documents',
    TICKET_TASKLIST: 'sidenav_ticketmgmt_ticket_tasklist',
    TICKET_SEND_MESSAGE: 'sidenav_ticketmgmt_ticket_send_message',
    TICKET_CANCEL: 'sidenav_ticketmgmt_ticket_cancel',
    TICKET_MARK_COMPLETE: 'sidenav_ticketmgmt_ticket_mark_as_complete',
    TICKET_REASSIGN: 'sidenav_ticketmgmt_ticket_reassign',
    TICKET_ASSIGN: 'sidenav_ticketmgmt_ticket_assign',
    TICKET_ATTACH: 'sidenav_ticketmgmt_ticket_add_attachment',
    TICKET_ADD_COMMENT: 'sidenav_ticketmgmt_ticket_add_comment',
    TICKET_RE_CLASSIFY: 'sidenav_ticketmgmt_ticket_re-classify',
    VIEW_MEMBER_ACCOUNT: 'sidenav_ticketmgmt_ticket_view_member_account',
    TICKET_DETAIL_TOOLTIP: 'sidenav_ticketmgmt_ticket_detail_toolTip',
    TICKET_HISTORY_TOOLTIP: 'sidenav_ticketmgmt_ticket_history_toolTip',
    TICKET_COMMENTS_TOOLTIP: 'sidenav_ticketmgmt_ticket_comments_toolTip',
    TICKET_DOCUMENTS_TOOLTIP: 'sidenav_ticketmgmt_ticket_documents_toolTip',
    TICKET_TASKLIST_TOOLTIP: 'sidenav_ticketmgmt_ticket_tasklist_toolTip',

    BACK: 'sidenav_ticketmgmt_ticket_back',
    TICKET_REPORTS: 'sidenav_ticketmgmt_manage_reports_Tab',
};

const { ADMIN, OPERATIONS, SUPERVISOR, L4_CSR, BA } = ALL_USER_ROLES;

const getManageTagsVisibility = (...args) => {
    let [activeModuleName = ''] = args;
    return (
        [ADMIN, OPERATIONS].includes(activeModuleName.toUpperCase()) &&
        ALL_USER_ROLES.SUPERVISOR.toLowerCase() !== activeModuleName
    );
};

const getExchangeAssigneesVisibility = (...args) => {
    let [activeModuleName = ''] = args;
    return [ADMIN, OPERATIONS, SUPERVISOR, L4_CSR].includes(activeModuleName.toUpperCase());
};

const getManageCustomFieldVisibility = (...args) => {
    let [activeModuleName = ''] = args;
    return [ADMIN, OPERATIONS].includes(activeModuleName.toUpperCase());
};

const getManageCannedResponseVisibility = (activeModuleName = '', state = '') => {
    const module = activeModuleName.toUpperCase();
    const isIdaho = state.toUpperCase() === IEX_STATE_CODES.ID;
    return module === ADMIN || (isIdaho && module === BA);
};

const getManageTicketTypesVisibility = (...args) => {
    let [activeModuleName = ''] = args;
    return [ADMIN, OPERATIONS].includes(activeModuleName.toUpperCase());
};

export const ticketManagementNavLinks = {
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [GETINSURED]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [NEVADA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [NEW_JERSEY]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [GEORGIA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [CALIFORNIA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [MINNESOTA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [IDAHO]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
    [ILLINOIS]: [
        {
            sectionHeader: 'sidenav_header_ticketmgmt',
            sectionItems: [
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_LIST,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_DEFAULT_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.TICKET_MGMT_MANAGE_QUEUE,
                    visibility: true,
                    text: ticketManagementNavLinkNames.MANAGE_WORKGROUP_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_TYPES,
                    visibility: getManageTicketTypesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TICKET_TYPES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_TAGS,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_TAGS,
                    visibility: getManageTagsVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_TAGS,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
                    visibility: getExchangeAssigneesVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_EXCHANGE_ASSIGNEES,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
                    visibility: getManageCustomFieldVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CUSTOM_FIELD,
                },
                {
                    name: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_MGMT_MANAGE_CANNED_RESPONSES,
                    visibility: getManageCannedResponseVisibility,
                    text: ticketManagementNavLinkNames.MANAGE_CANNED_RESPONSE,
                },
                {
                    name: ticketManagementNavLinkNames.TICKET_REPORTS,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.TICKET_REPORTS,
                    visibility: true,
                    text: ticketManagementNavLinkNames.TICKET_REPORTS,
                },
            ],
        },
    ],
};

const getTicketDetailSectionItems = encTicketId => [
    {
        name: ticketManagementNavLinkNames.TICKET_DETAIL,
        type: SIDENAV_LINKS_TYPES.LINK,
        path: endpoints.TICKET_MGMT_TICKET_DETAIL.processReplacements({ encTicketId }),
        visibility: true,
        text: ticketManagementNavLinkNames.TICKET_DETAIL,
        tooltipTextId: ticketManagementNavLinkNames.TICKET_DETAIL_TOOLTIP,
        hotkey: 's',
    },
    {
        name: ticketManagementNavLinkNames.TICKET_HISTORY,
        type: SIDENAV_LINKS_TYPES.LINK,
        path: endpoints.TICKET_MGMT_TICKET_HISTORY.processReplacements({ encTicketId }),
        visibility: true,
        text: ticketManagementNavLinkNames.TICKET_HISTORY,
        tooltipTextId: ticketManagementNavLinkNames.TICKET_HISTORY_TOOLTIP,
        hotkey: 'h',
    },
    {
        name: ticketManagementNavLinkNames.TICKET_COMMENTS,
        type: SIDENAV_LINKS_TYPES.LINK,
        path: endpoints.TICKET_MGMT_TICKET_COMMENTS.processReplacements({ encTicketId }),
        visibility: true,
        text: ticketManagementNavLinkNames.TICKET_COMMENTS,
        tooltipTextId: ticketManagementNavLinkNames.TICKET_COMMENTS_TOOLTIP,
        hotkey: 'c',
    },
    {
        name: ticketManagementNavLinkNames.TICKET_DOCUMENTS,
        type: SIDENAV_LINKS_TYPES.LINK,
        path: endpoints.TICKET_MGMT_TICKET_DOCUMENTS.processReplacements({ encTicketId }),
        visibility: hasPermission => hasPermission,
        text: ticketManagementNavLinkNames.TICKET_DOCUMENTS,
        tooltipTextId: ticketManagementNavLinkNames.TICKET_DOCUMENTS_TOOLTIP,
        hotkey: 'a',
    },
    {
        name: ticketManagementNavLinkNames.TICKET_TASKLIST,
        type: SIDENAV_LINKS_TYPES.LINK,
        path: endpoints.TICKET_MGMT_TICKET_TASKLIST.processReplacements({ encTicketId }),
        visibility: hasPermission => hasPermission,
        text: ticketManagementNavLinkNames.TICKET_TASKLIST,
        tooltipTextId: ticketManagementNavLinkNames.TICKET_TASKLIST_TOOLTIP,
        hotkey: 'k',
    },
];

export const ticketManagementTicketDetailNavLinks = Object.values(IEX_STATE_CODES).reduce((acc, stateCode) => {
    acc[stateCode] = [
        {
            sectionHeader: 'sidenav_header_ticketmgmt_about_this_ticket',
            sectionItems: getTicketDetailSectionItems(encTicketId),
        },
    ];
    return acc;
}, {});
